import { Formik } from 'formik';
import _ from 'lodash';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import FixedDropdown from '~/components/FixedDropdown';
import { FieldProjectTaskSelect } from '~/components/ProjectTaskSelect';
import { useApi, useWorkspace } from '~/contexts';
import settings from '~/settings';
import * as Yup from 'yup';

const Content = styled.div`
  display: grid;
  row-gap: 1.25rem;
`;

const ContentRow = styled.div``;

const TaskName = styled.strong`
  margin: 0 0.25rem;
`;

const InlineWrapper = styled.span`
  display: inline-flex;
  vertical-align: middle;
`;

const TaskSelectContainer = styled.div`
  width: 25rem;
`;

function AllocationRow() {
  return 'Allocation';
}

function MoveAllocationsConfirmation({ task, project, onClose, onComplete }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Move Allocations"
      onClose={onClose}
      onComplete={onComplete}
      confirmText="Move Allocations"
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={AllocationRow}>
      <Formik
        innerRef={formRef}
        initialValues={{ targetTask: null }}
        onSubmit={async (values) => {
          // Fetch the source task's allocation IDs, then move them in batches
          const {
            data: { ids },
          } = await api.www.workspaces(workspace.id).projects(project.id).tasks(task.id).allocationIds();
          const result = { rows: [], summary: { succeeded: 0, failed: 0, skipped: 0 } };
          for (const chunk of _.chunk(ids, settings.bulkActionItemLimit)) {
            const { data } = await api.www
              .workspaces(workspace.id)
              .projects(project.id)
              .tasks(task.id)
              .moveAllocations({ targetTaskId: values.targetTask.id, ids: chunk });
            result.rows.push(...data.rows);
            result.summary.succeeded += data.summary.succeeded;
            result.summary.failed += data.summary.failed;
            result.summary.skipped += data.summary.skipped;
          }
          return result;
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          targetTask: Yup.mixed().required().label('Task'),
        })}>
        <Form>
          <Content>
            <ContentRow>
              Move all allocations from <TaskName>{task.name}</TaskName> to another task in this project.
            </ContentRow>
            <ContentRow>
              <InlineWrapper>
                <TaskSelectContainer>
                  <FieldProjectTaskSelect
                    name="targetTask"
                    project={project}
                    placeholder="Select a task"
                    exclude={[task.id]}
                    component={FixedDropdown}
                    disableRollups
                    disableMilestones
                  />
                </TaskSelectContainer>
              </InlineWrapper>
            </ContentRow>
          </Content>
        </Form>
      </Formik>
    </BulkActionModal>
  );
}

export default MoveAllocationsConfirmation;
